import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePetitionActionsPageData } from '#src/app/pages/actions/pageContext';
import { useSupporterVoicesVideoFirstTrackingProps } from '#src/app/pages/actions/shared/hooks';
import { useCampaignTracking } from '#src/app/shared/hooks/campaignTracking';

import { useVideosComponentContext } from '../../../../../context';

import {
	CreatePetitionActionVideo,
	type CreatePetitionActionVideoMutation,
	type CreatePetitionActionVideoMutationVariables,
} from './useSave.graphql';

export function useSave() {
	const { track } = useCampaignTracking();
	const trackingProps = useSupporterVoicesVideoFirstTrackingProps();
	const {
		data: { petitionVideoList, videoSource },
		actions: { setPetitionVideoList, setUploadedVideoId },
	} = useVideosComponentContext();
	const {
		gql: { fetch },
	} = useUtilityContext();
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionActionsPageData();

	const save = async (variables: CreatePetitionActionVideoMutationVariables): Promise<{ id: string }> => {
		const { data } = await fetch<CreatePetitionActionVideoMutation, CreatePetitionActionVideoMutationVariables>({
			query: CreatePetitionActionVideo,
			variables,
			rejectOnError: true,
		});
		return { id: data.createPetitionSupporterVideo.id };
	};

	const createPetitionVideo = async ({ thumbnailUrl, videoUrl }: { thumbnailUrl: string; videoUrl: string }) => {
		const { id } = await save({
			petitionId,
			thumbnailUrl,
			videoUrl,
		});
		track('campaign_action_create_video_uploaded', {
			video_url: videoUrl,
			thumbnail_url: thumbnailUrl,
			video_source: videoSource,
			...trackingProps,
		});
		setPetitionVideoList([
			{
				id,
				petitionId,
				videoUrl,
				thumbnailUrl,
			},
			...petitionVideoList,
		]);
		setUploadedVideoId(id);
	};

	return { createPetitionVideo };
}
